import React from 'react';
import { Building2, Plus, AlertTriangle } from 'lucide-react';

interface SemEmpresaMessageProps {
  onCadastrarEmpresa: () => void;
}

const SemEmpresaMessage: React.FC<SemEmpresaMessageProps> = ({ onCadastrarEmpresa }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto p-8">
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Building2 className="w-10 h-10 text-yellow-600" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Nenhuma Empresa Cadastrada
        </h2>
        
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" />
            <div className="text-left">
              <p className="text-yellow-800 font-medium mb-2">
                Selecione ou cadastre uma empresa
              </p>
              <p className="text-yellow-700 text-sm">
                Para utilizar o sistema CIPA Fácil, você precisa ter pelo menos uma empresa cadastrada. 
                Todas as funcionalidades ficam bloqueadas até que uma empresa seja selecionada ou cadastrada.
              </p>
            </div>
          </div>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={onCadastrarEmpresa}
            className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 font-medium"
          >
            <Plus className="w-5 h-5" />
            Cadastrar Nova Empresa
          </button>
          
          <p className="text-sm text-gray-600">
            Após cadastrar uma empresa, você poderá acessar todas as funcionalidades do sistema.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SemEmpresaMessage;
